import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useEffect } from "react";

//Components
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';
import { Alert } from '@mui/material';

//Actions
import {
    clearRedux,
    keyfobsDeleteRequest,
} from 'Redux/actions';

const DeleteKeyFob = (props) => {
    const { tableRef } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const { openModal, loading, result, keyfob } = useSelector(state => state.deleteKeyFobRedux);
    
    const closeModal = () => {
        dispatch(clearRedux("KEYFOBS_DELETE"));
    }

    const applyChanges = () => {
        keyfob && dispatch(keyfobsDeleteRequest(keyfob?.id,keyfob?.hex));
    }

    useEffect(() => {
        if (result?.delete) {
            NotificationManager.success(
                messages['delete_keyfob_success_message'],
                messages['delete_keyfob_title'],
                3000
            );
            tableRef && tableRef.current?.getData({ newPage: 0 });
            closeModal();
        }
    }, [result])

    return (
        <Modal
            open={openModal}
            title={messages['delete_keyfob_title']}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <div style={{ padding: '0 10px' }}>
                    <p style={{ margin: 0 }}>{messages['delete_keyfob_label']}</p>
                    {keyfob?.hex ? <ul style={{ marginTop: 10 }}><li>{keyfob?.hex}</li></ul> : <></>}
                    <Alert
                        style={{ marginTop: 5 }}
                        severity="warning"
                    >
                        {messages['delete_keyfob_warning']}
                    </Alert>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={() => applyChanges()}
                >
                    {messages['delete']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default DeleteKeyFob;